import tenantUtils from '@utils';
import { NetworkService } from '../../../../services/networkService';
import { listingDetailMapper } from '../listings/listingsApis';

const staffLeadsMapper = (data) => {
  return {
    user_name: tenantUtils.getLocalisedString(data, 'name'),
    active_listings: {
      count: data?.active_listings_count,
      listings: data?.active_listings?.map((listing) => listingDetailMapper(listing)),
    },
    leads_count: data?.leads_count,
    performance_stats: [
      {
        title: 'Calls Answered Rate',
        icon: 'IoCall',
        value: '50%',
      },
      {
        title: 'Whatsapp Chats Rate',
        icon: 'RiWhatsappFill',
        value: '40%',
      },
    ],
  };
};

export const getStaffLeads = async (agencyId, page) => {
  const response = await NetworkService.get(`/api/lms/agencies/${agencyId}/staff?page=${page || 1}`);
  if (response?.error) {
    return response;
  } else {
    return {
      // filtersData: {
      //   list: [
      //     {
      //       label: "strings.purpose",
      //       list: [],
      //       type: 'select',
      //       key: 'purpose',
      //       placeholder: "strings.placeholders.purpose",
      //       box_title: 'Purpose',
      //       singleValue: true,
      //       labelProps: { muted: true },
      //     },
      //   ],
      // },
      table: [
        {
          title: 'Agent',
          dataIndex: 'user_name',
          key: 'user_name',
          component: 'String',
        },
        {
          title: 'Active Listings',
          dataIndex: 'active_listings',
          key: 'active_listings',
          component: 'StaffActiveListings',
        },
        {
          title: 'Leads',
          dataIndex: 'leads_count',
          key: 'leads_count',
          component: 'String',
        },
        {
          title: 'Performance',
          key: 'performance_stats',
          component: 'PerformanceStats',
        },
      ],
      list: response?.data?.users.map((item) => staffLeadsMapper(item)),
    };
  }
};
